export default __webpack_public_path__ + "static/media/bidifylogo_evmos.4d7068fd.png";